import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import AddressInfo from "./AddressInfo";
import CharityBasicInfo from "./CharityBasicInfo";
import { resetZipCode, resetAllZipFields, flushZipCode } from "../../../../../CommonComponents/Zipcode/actions";

class CharityForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formData: props.data,
            isCharityFormValid: false,
            isAddressFormValid: false,
        };
    }
    
    componentWillReceiveProps(nextProps) {
        this.setState({
        formData:nextProps.data
        });
    }

    updateCharityInfo = ({data, isFormValid}) => {
        this.setState((prevState) => {
            return {
                formData: {...prevState.formData, ...data},
                isCharityFormValid: isFormValid,
            }
        }, () => {
            this.props.handleFormChange({formData: this.state.formData , isFormValid : this.state.isAddressFormValid && this.state.isCharityFormValid}, this.props.successorKey)
        });
    }


    updateAddressInfo = ({data, isFormValid}) => {
        this.setState((prevState) => {
            return {
                formData: {...prevState.formData, ...data},
                isAddressFormValid: isFormValid,
            }
        }, () => {
            this.props.handleFormChange({formData: this.state.formData , isFormValid : this.state.isAddressFormValid && this.state.isCharityFormValid}, this.props.successorKey)
        });
    }

    render() {
        let legacyValues = this.state.formData;
        const {validateForm} = this.props;
        return (
        <div data-test="contentWrapper">
            <CharityBasicInfo
                data-test="contentCharityBasic"
                charityData={legacyValues}
                handleFormChange={this.updateCharityInfo}
                validateForm={validateForm}
                charityTotalPercent={this.props.charityTotalPercent}
                legacyFormValid= {this.props.legacyFormValid}
            />
            <AddressInfo
                data-test="contentAddress"
                addressData={legacyValues.address}
                stateDropDown={this.props.stateDropDown}
                countryDropDown={this.props.countryDropDown}
                successorKey={this.props.successorKey}
                contentKey={this.props.contentKey}
                handleFormChange={this.updateAddressInfo}
                validateForm={validateForm}
                tabkey={this.props.tabkey}
                legacyFormValid= {this.props.legacyFormValid}
                zipCodeData={this.props.zipCodeData.toJS()}
                resetZipCode={(val, field)=>this.props.resetZipCode(val, field)}
                resetAllZipCode={(val) => this.props.resetAllZipCode(val)}
            />
            
        </div>
        );
    }
}
const  descvalueShape = PropTypes.shape({
    desc: PropTypes.string,
    value: PropTypes.string
  })
CharityForm.propTypes = {
    charityTotalPercent: PropTypes.bool,
    contentKey: PropTypes.string,
    countryDropDown: PropTypes.arrayOf(descvalueShape),
    data: PropTypes.shape({
        address: PropTypes.shape({
          city: PropTypes.string,
          country: PropTypes.string,
          line1: PropTypes.string,
          line2: PropTypes.any,
          line3: PropTypes.any,
          state: PropTypes.string,
          zip: PropTypes.string
        }),
        charityAllocPercent: PropTypes.string,
        contactEmail: PropTypes.string,
        contactFirstName: PropTypes.string,
        contactLastName: PropTypes.string,
        contactPhone: PropTypes.string,
        ein: PropTypes.string,
        encryptedEin: PropTypes.any,
        grantMonth: PropTypes.any,
        grantPurpose: PropTypes.string,
        grantRecognition: PropTypes.string,
        name: PropTypes.string,
        notes: PropTypes.any,
        otherGrantPurposeText: PropTypes.string,
        successionDetailId: PropTypes.number,
        successionPlanId: PropTypes.number,
        webAddress: PropTypes.string
      }),    handleFormChange: PropTypes.func,
      legacyFormValid: PropTypes.bool,
      resetAllZipCode: PropTypes.func,
    resetZipCode: PropTypes.func,
    stateDropDown: PropTypes.arrayOf(descvalueShape),
    successorKey: PropTypes.number,
    tabkey: PropTypes.any,
    validateForm: PropTypes.bool,
    zipCodeData: PropTypes.object
  };

const mapStateToProps = (state, ownProps) => ({
  countryDropDown: state.getIn([
    "myAccount",
    "dropdownValues",
    "data",
    "countries"
  ]),
  stateDropDown: state.getIn(["myAccount", "dropdownValues", "data", "states"]),
  zipCodeData: state.getIn(['zipCode', 'zipCodes'])
});

const mapDispatchToProps = dispatch => ({
    resetZipCode: (val, field) => dispatch(resetZipCode(val, field)),
    resetAllZipCode: (val) => dispatch(resetAllZipFields(val)),
    flushZipCode: () => dispatch(flushZipCode())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CharityForm);
